(function(){
  var desktop=window.matchMedia('(hover: hover) and (min-width: 990px)');
  document.querySelectorAll('.header__inline-menu details').forEach(function(d){
    var li=d.closest('li'), s=d.querySelector('summary');
    li.addEventListener('mouseenter',function(){ if(!desktop.matches) return; d.setAttribute('open',''); s&&s.setAttribute('aria-expanded','true'); });
    li.addEventListener('mouseleave',function(){ if(!desktop.matches) return; d.removeAttribute('open'); s&&s.setAttribute('aria-expanded','false'); });
  });
  document.querySelectorAll('.header__inline-menu .fotg-parent-link').forEach(function(a){
    a.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); window.location.href=a.getAttribute('href'); });
  });
})();
